import { GridItem as ChakraGridItem } from "@chakra-ui/react";
import { forwardRef, type ComponentProps } from "react";
import type { GridItemSharedProps } from "./GridItem.props";

type ChakraGridItemProps = ComponentProps<typeof ChakraGridItem>;

export type GridItemProps = GridItemSharedProps & {
  // Add any web specific props here.
};

const GridItem = forwardRef<HTMLDivElement, GridItemProps>(function GridItem(
  props,
  ref
): JSX.Element {
  return (
    <ChakraGridItem ref={ref} {...(props as unknown as ChakraGridItemProps)} />
  );
});

export default GridItem;
